import { useEffect, useState } from 'react';
import type { FormState, FormWorker } from './form_worker';

export function useFormWorkerState(formWorker: Readonly<FormWorker>): Readonly<FormState> {
	const [, forceUpdate] = useState([]);

	useEffect(() => {
		return formWorker.events.on('onChange', () => {
			forceUpdate([]);
		});
	}, [formWorker]);

	return formWorker.getState();
}
